import Grid from '@mui/material/Grid';
import { MenuItem, Select } from '@mui/material';
import W86PlaceholderTextField from '../W86Components/W86PlaceholderTextField';
import getPlaceholderColors from '../../utils/placeholderColors';
import React, { Component } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import replacePlaceholderValue from '../../utils/ReplacePlaceholderValue';
import checkKey from '../../utils/CheckKey';
import FormMentionEditor from '../Component/FormMentionEditor';

class AIPlaceholderItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkKey: false,
      errorMessage: '',
      showWarning: false,
    };
  }

  setPlaceholderType = (index, value) => {
    let aData = this.props.aiAssistantData.outputPlaceholders[index];
    aData.type = value;
    this.props.setAIPlaceholder(this.props.aiAssistantData.outputPlaceholders);
  };

  setDesc = (index, value) => {
    let aData = this.props.aiAssistantData.outputPlaceholders[index];
    aData.desc = value;
    this.props.setAIPlaceholder(this.props.aiAssistantData.outputPlaceholders);
  };

  setKey = (index, value) => {
    let keyValue = replacePlaceholderValue(value);
    const ckValue = checkKey(keyValue, index, this.props.aiAssistantData.outputPlaceholders);
    this.setState({
      checkKey: ckValue[0],
      errorMessage: ckValue[1],
    });
    let aData = this.props.aiAssistantData.outputPlaceholders[index];
    aData.key = keyValue;
    this.props.setAIPlaceholder(this.props.aiAssistantData.outputPlaceholders);
  };

  deletePlaceholders = (index) => {
    this.props.aiAssistantData.outputPlaceholders.splice(index, 1);
    this.props.setAIPlaceholder(this.props.aiAssistantData.outputPlaceholders);
  };

  render() {
    const { aData, index, availablePlaceholders, placeholderTypeMap } = this.props;

    return (
      <Grid
        container
        item
        spacing={1}
        direction="column"
        style={{
          background: 'var(--color-bg-subtle)',
          marginBottom: 16,
          padding: '12px 12px 12px 12px',
          position: 'relative',
          borderRadius: 4,
        }}
      >
        <CloseIcon
          onClick={() => this.deletePlaceholders(index)}
          style={{
            position: 'absolute',
            top: 8,
            right: 10,
            cursor: 'pointer',
            zIndex: 1,
            fontSize: 20,
          }}
        />

        <Grid item>
          <span style={{ fontSize: 14 }}>
            <b>Describe the output</b>
          </span>
        </Grid>

        <Grid item>
          <FormMentionEditor
            availablePlaceholders={availablePlaceholders}
            text={aData.desc}
            onChange={(html) => this.setDesc(index, html)}
            placeholder=""
            aiAssistant={true}
            style={{
              width: '100%',
              verticalAlign: 'top',
              minHeight: '16px',
              fontSize: '14px',
              background: 'var(--color-bg-paper)',
            }}
            onFocus={() => {}}
            contentBlock={false}
            hideScrollBar={true}
            assignTask={true}
            {...(availablePlaceholders != null && {
              availablePlaceholders: availablePlaceholders[0].placeholders,
            })}
          />
        </Grid>

        <Grid item style={{ paddingTop: 8 }}>
          <span style={{ fontSize: 14 }}>
            <b>Placeholder</b>
          </span>
        </Grid>

        <Grid item>
          <div style={{ width: '90%', background: 'var(--color-bg-paper)' }}>
            <W86PlaceholderTextField
              value={aData.key}
              fullWidth={true}
              handleChange={(event) => this.setKey(index, event.target.value)}
              error={this.state.checkKey}
              helperText={this.state.checkKey ? this.state.errorMessage : null}
              placeholderText="Enter placeholder for update table"
              style={{ background: 'var(--color-bg-paper)' }}
            />
          </div>
        </Grid>

        <Grid item>
          <Select
            defaultValue="text"
            className="joditPlaceholderIcon"
            inputProps={{ IconComponent: () => null }}
            size="small"
            sx={{
              backgroundColor: 'var(--color-bg-subtle)',
              '--custom-icon': `url(${getPlaceholderColors('text', null).icon})`,
              verticalAlign: 'top',
            }}
            variant="outlined"
            value={aData.type}
            onChange={(event) => this.setPlaceholderType(index, event.target.value)}
          >
            {placeholderTypeMap.map((aCol) => (
              <MenuItem
                key={aCol}
                value={aCol.toLowerCase()}
                className="joditPlaceholderIcon"
                style={{
                  '--custom-icon': `url(${getPlaceholderColors(aCol.toLowerCase(), null).icon})`,
                  paddingTop: 8,
                  paddingBottom: 8,
                }}
              >
                {aCol}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
    );
  }
}

export default AIPlaceholderItem;
